// reportname.common.mixin.js
import {resolveReportTemplate} from './report-template';
import {tenant} from '@shared/utils/tenant';

const {supplyCoverTitle, supplyFilename} = require('./report-self-assessment.cjs');
const {ksteelReportYear} = require('./report-ksteel-year.cjs');

export default {
    computed: {
        // 판정 단일 지점 — 백엔드 스냅샷 필드 우선, env 화이트리스트 폴백 (report-template.js).
        // 입력 선택(view 이력 vs 미리보기 데이터)의 조건은 종전 IS_* 6개 computed 가 복붙하던 것과 동일하다.
        resolved_report_template () {
            const useView = typeof this.view !== 'undefined' && typeof this.view_target_report !== 'undefined' && this.view && this.view_target_report?.report?.campaign_id;
            if (useView) {
                return resolveReportTemplate({
                    rendererKey: this.view_target_report.report.report_renderer_key,
                    campaignId: this.view_target_report.report.campaign_id,
                    fallbackRenderer: tenant && tenant.defaultRenderer,
                });
            }
            return resolveReportTemplate({
                rendererKey: this.reportData?.report_meta?.report_renderer_key,
                campaignId: this.reportData?.info?.campaign?.id,
                fallbackRenderer: tenant && tenant.defaultRenderer,
            });
        },
        IS_HMC () {
            return this.resolved_report_template === 'hmc';
        },
        IS_HMC_2025 () {
            return this.resolved_report_template === 'hmc_2025';
        },
        IS_HYUNDAI_V2 () {
            return this.resolved_report_template === 'hyundai_v2';
        },
        IS_HMC_THEME () {
            return this.resolved_report_template === 'hmc_theme';
        },
        IS_KIA () {
            return this.resolved_report_template === 'kia';
        },
        IS_HYUNDAI () {
            return this.resolved_report_template === 'hyundai';
        },
        IS_KSTEEL(){
            return this.resolved_report_template === 'ksteel';
        },
        IS_SUPPLY(){
            return this.resolved_report_template === 'supply';
        },
        report_filename () {
            if (this.IS_HMC) {
                return '2024_HMG_Supplier_ESG_Assessment_Report';
            }
            else if (this.IS_HMC_2025) {
                return '2025_Hyundai_Motor_Company_Kia_Supplier_ESG_Evaluation_Report';
            }
            else if (this.IS_HYUNDAI_V2) {
                return '2026_Hyundai_Motor_Business_Site_ESG_Assessment_Report';
            }
            else if (this.IS_HMC_THEME) {
                return '2026_Hyundai_Motor_Company_Kia_Supply_Chain_ESG_Theme_Assessment_Report';
            }
            else if (this.IS_KIA) {
                return '2025_Kia_Business_Site_Human_Rights_&_Environmental_Due_Diligence_Online_Assessment';
            } else if(this.IS_HYUNDAI){
                return '2025_Hyundai_Motor_Company_Kia_Supplier_ESG_Evaluation';
            }
            else if(this.IS_KSTEEL){
                return `${ksteelReportYear(this.reportData?.info?.project_code)} 철강 공급망 ESG 실사_서면평가 결과보고서`;
            }
            else if(this.IS_SUPPLY){
                // 자가진단·넥센 서면평가는 프로젝트 코드로 표지·파일명을 바꾼다 (report-self-assessment.cjs). 그 밖은 그대로.
                return supplyFilename('2026 공급망 ESG 실사_서면평가 결과보고서', this.report_lang, this.reportData?.info?.project_code);
            }
            else {
                return 'TEMPORAL_REPORT_NAME';
                
            }
        },
        cover_title () {
            if (this.IS_HYUNDAI_V2) {
                switch (this.report_lang) {
                case 'ca':
                    return ['2026年现代汽车法人ESG评价'];
                case 'en':
                    return [
                        '2026 Hyundai Motor',
                        'Business Site ESG Assessment'
                    ];
                default:
                    return [
                        '2026년 현대차 사업장 ESG 평가'
                    ];
                }
            }
            else if(this.IS_HYUNDAI) {
                switch (this.report_lang) {
                case 'ca':
                    return '2025现代汽车法人ESG评价';
                case 'en':
                    return [
                        '2025 Hyundai Motor',
                        'Business Site ESG Assessment'
                    ];
                default:
                    return [
                        '2025년 현대차',
                        '사업장 ESG 평가',
                    ];
                }
            }
            else if (this.IS_KIA) {
                switch (this.report_lang) {
                case 'ca':
                    return '2025年起亚商业场所人权与环境尽职调查在线评估';
                case 'en':
                    return '2025 Kia Business Site Human Rights & Environmental Due Diligence Online Assessment';
                default:
                    return '2025 기아 사업장 인권/환경 실사 서면진단';
                }
            } 
            else if (this.IS_HMC) {
                switch (this.reportData?.info?.campaign?.id) {
                case 503:
                    switch (this.report_lang) {
                    case 'ca':
                        return '2024年现代汽车•起亚 / 现代现代摩比斯 ESG 供应商评估';
                    case 'en':
                        return '2024 Hyundai Motor Company • Kia / Hyundai Mobis ESG Supplier Evaluation';
                    default:
                        return '2024년 현대차 • 기아 • 현대모비스 ESG 평가';
                    }
                case 502:
                default:
                    switch (this.report_lang) {
                    case 'ca':
                        return '2024年 现代汽车•起亚 ESG 供应商评估';
                    case 'en':
                        return '2024 Hyundai Motor Company • Kia ESG Supplier Evaluation';
                    default:
                        return '2024년 현대자동차 • 기아 ESG 평가';
                    }
                }
            }
            else if(this.IS_HMC_2025) {
                switch (this.report_lang) {
                case 'ca':
                    return [
                        '2025年现代汽车•起亚',
                        '供应商ESG评估'
                    ];
                case 'en':
                    return [
                        '2025 Hyundai Motor Company • Kia',
                        'Supplier ESG Evaluation'
                    ];
                default:
                    return [
                        '2025년 현대자동차 • 기아',
                        '협력사 ESG 평가',
                    ];
                }
            }
            else if(this.IS_KSTEEL) {
                const _year = ksteelReportYear(this.reportData?.info?.project_code);
                switch (this.report_lang) {
                case 'ca':
                    return [
                        '韩国钢铁协会',
                        `${_year}年钢铁供应链ESG尽职调查`,
                    ];
                case 'en':
                    return [
                        'Korea Iron & Steel Association',
                        `${_year} Steel Supply Chain ESG Evaluation`,
                    ];
                default:
                    return [
                        '한국철강협회',
                        `${_year}년 철강 공급망 ESG 실사`,
                    ];
                }
            }
            else if(this.IS_SUPPLY) {
                let _lines;
                switch (this.report_lang) {
                case 'ca':
                    _lines = [
                        'QESG',
                        '2026年供应链ESG尽职调查',
                    ];
                    break;
                case 'en':
                    _lines = [
                        'QESG',
                        '2026 Supply Chain ESG Evaluation',
                    ];
                    break;
                default:
                    _lines = [
                        'QESG',
                        '2026년 공급망 ESG 실사',
                    ];
                }
                return supplyCoverTitle(_lines, this.report_lang, this.reportData?.info?.project_code);
            }
            else if(this.IS_HMC_THEME) {
                switch (this.report_lang) {
                case 'ca':
                    return [
                        '2026 现代汽车·起亚',
                        '供应链ESG主题评估'
                    ];
                case 'en':
                    return [
                        '2026 Hyundai Motor·Kia',
                        'Supply Chain ESG Theme Assessment'
                    ];
                default:
                    return [
                        '2026 현대차·기아',
                        '공급망 ESG 테마 평가',
                    ];
                }
            }
            else {
                return '';
            }
        },
    }
};
